import React, { SyntheticEvent, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import Button, { ButtonProps } from "@material-ui/core/Button";

import { setActiveLink as setStoreActiveLink } from "store/actions/sidebar";
import { useLoggedInUser } from "components/LoggedInUserProvider";
import LogoIcon from "components/Icons/SapLogo";
import routes from "common/routes";

import useStyles from "./styles";

interface IProps extends ButtonProps {
  onClickLogo: (
    event: SyntheticEvent,
    route: string,
    state?: Record<string, any>
  ) => void;
}

const LogoIconButton = (props: IProps) => {
  const { onClickLogo } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { currentUser } = useLoggedInUser();

  const getHomePath = () => {
    if (!currentUser.roles.length) return routes.account.path;
    if (currentUser.isVeterinarian) return routes.workouts.path;
    if (currentUser.isRacingOfficial) return routes.workouts.path;
    return routes.dashboard.path;
  };

  const handleClickLogo = (event: SyntheticEvent) => {
    const path = getHomePath();

    onClickLogo(event, path);
  };

  useEffect(() => {
    if (currentUser.isLoaded) {
      const path = `/${location.pathname.split("/")[1]}`;
      dispatch(setStoreActiveLink(path === "/" ? getHomePath() : path));
    }
  }, [currentUser.isLoaded, history.location.pathname]);

  return (
    <Button
      className={classes.logoButton}
      onClick={handleClickLogo}
      data-path={getHomePath()}
      data-test-id={"logoButton"}
    >
      <LogoIcon className={classes.logoIcon} />
    </Button>
  );
};

export default LogoIconButton;
